import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * @file Emitter Typed event emitter.
 * @author yuzong(yuzong@tencent.com)
 */
import { mixin as _mixin } from '@tencent/glue-util-helper';
import { getKeys } from '@tencent/glue-util-types';
var EVENT_CACHE_KEY = Symbol('__EVENT_CACHE_KEY__');
var GLOBAL_CACHE_KEY = Symbol('__GLOBAL_CACHE_KEY__');
/**
 * Typed event emitter.
 *
 */

export var Emitter = /*#__PURE__*/function () {
  function Emitter() {
    _classCallCheck(this, Emitter);
  }

  _createClass(Emitter, [{
    key: "addGlobalListener",
    value:
    /**
     * Add an event listener to handle all events.
     *
     * @param listener Listener function.
     */
    function addGlobalListener(listener) {
      var listeners = this[GLOBAL_CACHE_KEY] || [];
      listeners.push(listener);
      this[GLOBAL_CACHE_KEY] = listeners;
    }
    /**
     * remove global handlers.
     *
     * @param listener Listener function.
     */

  }, {
    key: "removeGlobalListener",
    value: function removeGlobalListener(listener) {
      var listeners = this[GLOBAL_CACHE_KEY];

      if (!listeners || !listener) {
        this[GLOBAL_CACHE_KEY] = [];
        return;
      }

      var index = listeners.findIndex(function (item) {
        return item === listener;
      });

      if (index >= 0) {
        listeners.splice(index, 1);
      }
    }
    /**
     * Add an event listener.
     *
     * @param type Event type.
     * @param listener Listener function.
     */

  }, {
    key: "addListener",
    value: function addListener(type, listener) {
      var map = this[EVENT_CACHE_KEY] = this[EVENT_CACHE_KEY] || {};
      var listeners = map[type];

      if (listeners == null) {
        listeners = [];
        map[type] = listeners;
      }

      listeners.push({
        fn: listener
      });
    }
    /**
     * Remove an event listener.
     *
     * @param type Event type, remove all event listeners if not passed.
     * @param listener Listener function, remove all event listeners in `type` if not passed.
     */

  }, {
    key: "removeListener",
    value: function removeListener(type, listener) {
      var map = this[EVENT_CACHE_KEY];

      if (type == null || map == null) {
        this[EVENT_CACHE_KEY] = {};
        return;
      }

      var listeners = map[type];

      if (listeners == null) {
        return;
      }

      if (listener == null) {
        delete map[type];
        return;
      }

      var index = listeners.findIndex(function (item) {
        return item.fn === listener;
      });

      if (index >= 0) {
        listeners.splice(index, 1);
      }
    }
    /**
     * Remove all event listeners in `type`.
     *
     * @param type Event type, remove all event listeners if not passed.
     */

  }, {
    key: "removeAllListeners",
    value: function removeAllListeners(type) {
      this.removeListener(type);
      this.removeGlobalListener();
    }
    /**
     * Emit an event.
     *
     * @param type Event type.
     * @param params Listener parameters.
     */

  }, {
    key: "emit",
    value: function emit(type) {
      var globalListeners = this[GLOBAL_CACHE_KEY] || [];

      for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        params[_key - 1] = arguments[_key];
      }

      if (globalListeners.length) {
        var _iterator = _createForOfIteratorHelper(globalListeners),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var listener = _step.value;
            listener(type, params);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      var map = this[EVENT_CACHE_KEY] = this[EVENT_CACHE_KEY] || {};
      var listeners = map[type];

      if (listeners == null) {
        return;
      }

      var _iterator2 = _createForOfIteratorHelper(listeners),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _listener = _step2.value;

          _listener.fn.apply(this, params);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
    /**
     * Delay triggering event until next commit.
     *
     * @param type Event type.
     * @param params Listener parameters.
     */

  }, {
    key: "waitForCommit",
    value: function waitForCommit(type) {
      var map = this[EVENT_CACHE_KEY] = this[EVENT_CACHE_KEY] || {};
      var listeners = map[type];

      if (listeners == null) {
        return;
      }

      for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        params[_key2 - 1] = arguments[_key2];
      }

      var _iterator3 = _createForOfIteratorHelper(listeners),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var listener = _step3.value;
          listener.waiting = params;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
    /**
     * Commit all waiting commit.
     *
     * @param type Event type, commit all event listeners if not passed.
     */

  }, {
    key: "commit",
    value: function commit(type) {
      var _this = this;

      var map = this[EVENT_CACHE_KEY] = this[EVENT_CACHE_KEY] || {};

      if (type == null) {
        getKeys(map).forEach(function (key) {
          return _this.commit(key);
        });
        return;
      }

      var listeners = map[type];

      if (listeners == null) {
        return;
      }

      var _iterator4 = _createForOfIteratorHelper(listeners),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var listener = _step4.value;
          var params = listener.waiting;

          if (params != null) {
            listener.waiting = void 0;
            this.emit.apply(this, [type].concat(_toConsumableArray(params)));
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
    /**
     * abort waiting commits.
     *
     * @param type Event type, abort all event listeners if not passed.
     */

  }, {
    key: "abortCommit",
    value: function abortCommit(type) {
      var _this2 = this;

      var map = this[EVENT_CACHE_KEY] = this[EVENT_CACHE_KEY] || {};

      if (type == null) {
        getKeys(map).forEach(function (key) {
          return _this2.abortCommit(key);
        });
        return;
      }

      var listeners = map[type];

      if (listeners == null) {
        return;
      }

      var _iterator5 = _createForOfIteratorHelper(listeners),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var listener = _step5.value;

          if (listener.waiting != null) {
            listener.waiting = void 0;
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
    /**
     * Get all listeners in `type`.
     *
     * @param type Event type.
     */

  }, {
    key: "listeners",
    value: function listeners(type) {
      var map = this[EVENT_CACHE_KEY] = this[EVENT_CACHE_KEY] || {};
      var listeners = map[type];

      if (listeners == null) {
        return [];
      }

      return listeners.map(function (item) {
        return item.fn;
      });
    }
    /**
     * Get listener count.
     *
     * @param type Event type.
     */

  }, {
    key: "listenerCount",
    value: function listenerCount(type) {
      var map = this[EVENT_CACHE_KEY] = this[EVENT_CACHE_KEY] || {};
      var listeners = map[type];

      if (listeners == null) {
        return 0;
      }

      return listeners.length;
    }
  }], [{
    key: "mixin",
    value:
    /**
     * Mixin emitter into target Function.
     *
     * @param Fn The target function.
     */
    function mixin(Fn) {
      _mixin(Fn, Emitter);
    }
  }]);

  return Emitter;
}();